/** Route guard. Cosmetic only: the API enforces the same rules server-side. */

import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@/features/auth/AuthContext';
import { FullPageSpinner } from '@/components/ui/Spinner';
import type { UserRole } from '@/types/api';

interface Props {
  roles?: UserRole[];
}

export function ProtectedRoute({ roles }: Props) {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <FullPageSpinner label="Vérification de la session…" />;

  if (status === 'anonymous' || !user) {
    return <Navigate to="/connexion" state={{ from: location.pathname }} replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/acces-refuse" replace />;
  }

  return <Outlet />;
}
